<template>
  <div>
    <c-card reference="Climb > Motivos Bloqueio" title="Motivos Bloqueio">
      <template slot="icons">
        <icon class="icon" @click="novoMotivoBloqueio" icon="plus"></icon>
        <icon class="icon" @click="abrirFiltros" icon="filter">
          <span v-if="totalFilters" class="card-icons-alert"
            >@{{ totalFilters }}</span
          >
        </icon>
      </template>
      <c-list :items="motivosBloqueio" class="mb-3">
        <template v-slot:items="item">
          <div class="d-flex justify-content-between w-100">
            <div class="d-flex flex-column">
              <div>
                <span
                  style="font-size: .9em; color: #222; font-weight: bold;"
                  >{{ item.data.descricao }}</span
                >
              </div>
              <span style="font-size: .8em; color: #6f6f6f">{{
                item.data.dica
              }}</span>
            </div>
            <div class="list-icons">
              <icon
                class="icon"
                @click="editarProfissao(item.data)"
                icon="pen"
              ></icon>
            </div>
          </div>
        </template>
      </c-list>
      <span class="card-divisor mb-3"></span>

      <div class="d-flex justify-content-between">
        <span style="font-size: .8em;font-weight: bold;">
          {{ (page - 1) * limit + 1 }} -
          {{ page * limit > totalRows ? totalRows : page * limit }} /
          {{ totalRows }}
        </span>
        <b-pagination
          v-model="page"
          :total-rows="totalRows"
          :per-page="limit"
          aria-controls="my-table"
          pills
          size="sm"
          class="mb-0"
          @change="loadMotivosBloqueio"
        ></b-pagination>
      </div>
    </c-card>

    <c-modal title="Motivo bloqueio" v-model="modalMotivosBloqueio" size="full">
      <template v-slot:buttons>
        <button v-if="!loading" @click="salvarMotivoBloqueio">Salvar</button>
        <button v-else @click="salvarMotivoBloqueio" :disabled="loading">
          <b-spinner class="mr-2" small></b-spinner> Cadastrando Motivo Bloqueio
        </button>
      </template>

      <b-row>
        <b-col>
          <b-form-group
            label-size="sm"
            v-for="(field, i) in commonFields"
            :key="i"
            :label="field.name"
            :label-for="field.attribute"
          >
            <b-form-input
              id="field.attribute"
              v-if="field.attribute != 'dica'"
              v-model="motivoBloqueio[field.attribute]"
              type="text"
              :disabled="loading"
            ></b-form-input>

            <b-form-textarea
              id="field.attribute"
              v-if="field.attribute == 'dica'"
              v-model="motivoBloqueio[field.attribute]"
              :disabled="loading"
              rows="6"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
    </c-modal>

    <c-modal title="Filtro" v-model="modalFiltro" size="md">
      <template v-slot:buttons>
        <button @click="limparFiltros">Limpar</button>
        <button @click="filtrarMotivosBloqueio">Filtrar</button>
      </template>
      <b-row>
        <b-col>
          <b-form-group
            label-size="sm"
            label="Descrição"
            label-for="filtro-descricao"
          >
            <b-form-input
              id="filtro-descricao"
              v-model="temporaryFilters.descricao"
              type="text"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </c-modal>
  </div>
</template>

<script>
import motivosBloqueioService from "@/services/MotivosbloqueioService.js";

import CList from "@/components/CList.vue";
import CCard from "@/components/CCard.vue";
import CModal from "@/components/CModal.vue";

import { mapActions } from "vuex";

export default {
  name: "MotivosBloqueio",
  data() {
    return {
      motivosBloqueio: [],
      motivoBloqueio: [],
      modalMotivosBloqueio: false,
      commonFields: [
        { name: "Descrição", attribute: "descricao" },
        { name: "Dica", attribute: "dica" }
      ],
      modalFiltro: false,
      temporaryFilters: {},
      loading: false,
      filters: {
        descricao: null
      },
      limit: 15,
      page: 1,
      totalRows: 0
    };
  },
  methods: {
    ...mapActions("notification", { notificate: "add" }),
    loadMotivosBloqueio(pageNumber) {
      motivosBloqueioService
        .getAll(this.limit, pageNumber, this.filters)
        .then(res => {
          this.motivosBloqueio = res.data.data;
          this.totalRows = res.data.totalRows;
        })
        .catch(err => {
          this.notificate({ text: err.message, variant: "danger" });
        });
    },
    abrirFiltros() {
      this.temporaryFilters = JSON.parse(JSON.stringify(this.filters));
      this.modalFiltro = true;
    },
    filtrarMotivosBloqueio() {
      this.page = 1;
      this.modalFiltro = false;
      this.filters = JSON.parse(JSON.stringify(this.temporaryFilters));
      this.loadMotivosBloqueio();
    },
    novoMotivoBloqueio() {
      this.motivoBloqueio = {
        descricao: null,
        dica: null
      };

      this.loading = false;
      this.modalMotivosBloqueio = true;
    },
    limparFiltros() {
      Object.keys(this.temporaryFilters).forEach(k => {
        this.temporaryFilters[k] = null;
      });
    },
    salvarMotivoBloqueio() {
      this.loading = true;

      if (this.motivoBloqueio.id) {
        motivosBloqueioService
          .update(this.motivoBloqueio.id, this.motivoBloqueio)
          .then(res => {
            this.loading = false;

            if (res.data.errors) {
              Object.keys(res.data.errors).forEach(k => {
                res.data.errors[k].forEach(e => {
                  this.notificate({ text: e, variant: "danger" });
                });
              });
              return;
            }

            this.modalMotivosBloqueio = false;

            res = "Motivo bloqueio alterado com sucesso";

            this.loadMotivosBloqueio();

            this.notificate({ text: res, variant: "success" });
          })
          .catch(err => {
            this.loading = false;
            this.notificate({ text: err.message, variant: "danger" });
          });
      } else {
        motivosBloqueioService
          .create(this.motivoBloqueio)
          .then(res => {
            this.loading = false;

            if (res.data.errors) {
              Object.keys(res.data.errors).forEach(k => {
                res.data.errors[k].forEach(e => {
                  this.notificate({ text: e, variant: "danger" });
                });
              });
              return;
            }

            this.modalMotivosBloqueio = false;

            res = "Motivo bloqueio cadastrado com sucesso";

            this.loadMotivosBloqueio();

            this.notificate({ text: res, variant: "success" });
          })
          .catch(err => {
            this.loading = false;
            this.notificate({ text: err.message, variant: "danger" });
          });
      }
    },
    editarProfissao(motivoBloqueio) {
      this.motivoBloqueio = {
        ...JSON.parse(JSON.stringify(motivoBloqueio))
      };

      this.modalMotivosBloqueio = true;
    }
  },
  components: {
    CList,
    CCard,
    CModal
  },
  computed: {
    totalFilters() {
      return Object.keys(this.filters).filter(
        k => this.filters[k] && this.filters[k] != ""
      ).length;
    }
  },
  mounted() {
    this.loadMotivosBloqueio(1);
  }
};
</script>
